import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import {elementsInLoading, isLoadingByGroupToggle} from "../../../@signals";


export default function usePriceDiscountCandlestickData() {
	const { urlApi } = usePricingDiscountRoleConfig()

	const isLoading = useSignal(false)
	const data = useSignal([])
	const minDiscount = useSignal(null)
	const maxDiscount = useSignal(null)
	const rowHeight = useSignal(70)

	useEffect(() => {
		if (isLoadingCommonFilters.value || isLoadingByGroupToggle.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${urlApi}/candlestick`, { ...commonFiltersValue.value }).then(res => batch(() => {
				data.value = res.candlestick
				maxDiscount.value = res.maxDiscount > 100 ? 100 : res.maxDiscount
				minDiscount.value = res.minDiscount < -100 ? -100 : res.minDiscount
				rowHeight.value = res.maxNumSkus
			})).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value, groupedBy.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'candlestick']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'candlestick')
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value,
		maxDiscount: maxDiscount.value,
		minDiscount: minDiscount.value,
		rowHeight: rowHeight.value
	}
}